var _circle, _g, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Chat",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12,
    cy: 12,
    r: 12,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    d: "M3.222,18.778A11,11,0,1,1,18.778,3.222a11.007,11.007,0,0,1,2.1,12.622l.757,3.406a2,2,0,0,1-1.518,2.386,2,2,0,0,1-.868,0l-3.406-.757a11.007,11.007,0,0,1-12.622-2.1ZM2,11a9,9,0,0,0,13.237,7.943,1.007,1.007,0,0,1,.472-.118,1.024,1.024,0,0,1,.216.023l3.758.835-.835-3.758a1,1,0,0,1,.094-.688A9,9,0,1,0,2,11Zm10,0a2,2,0,1,1,2,2A2,2,0,0,1,12,11ZM6,11a2,2,0,1,1,2,2A2,2,0,0,1,6,11Z",
    fill: "#92929d"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Notification",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(16)",
    fill: "#fc5a5a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForum);
export default __webpack_public_path__ + "static/media/forum.52bfc6ee.svg";
export { ForwardRef as ReactComponent };